import { Component, defineComponent } from 'vue';

import {
	SelectedFilters,
	SearchFilterContainer,
	AttendanceFilter,
	DisciplineFilter,
	DurationFilter,
	EducationLevelFilter,
	FormatFilter,
	LocationFilter,
	SpecialProgrammesFilter,
	TuitionFeeFilter
} from '@studyportals/search-filters';

export default defineComponent({
	components: {
		SelectedFilters: SelectedFilters as Component,
		SearchFilterContainer: SearchFilterContainer as Component,
		DisciplineFilter: DisciplineFilter as Component,
		EducationLevelFilter: EducationLevelFilter as Component,
		LocationFilter: LocationFilter as Component,
		AttendanceFilter: AttendanceFilter as Component,
		DurationFilter: DurationFilter as Component,
		FormatFilter: FormatFilter as Component,
		TuitionFeeFilter: TuitionFeeFilter as Component,
		SpecialProgrammesFilter: SpecialProgrammesFilter as Component
	}
});
